module.exports = ['$utils', '$q', 'Message', 'User', 'mailService',
  function ($utils, $q, Message, User, mailService) {
    function KeywordSearchMail(searchField, keyword, dealings, start, order, limit) {
      this.keyword = keyword
      this.condictions = searchField ? [
        {
          field: searchField,
          operator: 'contains',
          operand: this.keyword,
        }
      ] : [] // 搜索过滤条件
      /** todo: 往来邮件不应该放在这里定义 */
      this.dealings = dealings
      this.start = start || 0 // 处理搜索分页显示
      this.order = order || 'receivedDate'
      this.limit = limit || 20 //  搜索分页个数
      this.messages = []
    }

    KeywordSearchMail.prototype.getMid = function (mboxa) {
      const self = this
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:searchMessages',
          sid: User.getCurrentUser().sid
        },
        data: {
          mboxa,
          start: self.start,
          refresh: true,
          pattern: self.keyword,
          order: self.order,
          desc: true,
          condictions: self.condictions
        }
      }).then(function (data) {
        if (data['code'] == 'S_OK') {
          self.mids = data['var']
          self.totals = self.mids.length
          deferred.resolve(data)
        } else {
          deferred.reject(data)
        }
      }, function (error) {
        deferred.reject(error)
      })

      return deferred.promise
    }

    //  根据mid获取邮件信息
    KeywordSearchMail.prototype.fetchMessages = function (iStart, mboxa) {
      const self = this
      const deferred = $q.defer()

      iStart = iStart || 0
      const fetchMessages = function () {
        if (self.messages[iStart]) {
          deferred.resolve(self.messages.slice(iStart, iStart + (self.limit || 0)))
          return deferred.promise
        }
        mailService.getMessageInfos({
          ids: self.mids.slice(iStart, iStart + (self.limit || 0)),
          pattern: self.keyword,
          desc: true,
          mboxa,
        }).then(function (data) {
          const messages = Message.buildMessages(data)
          self.messages = self.messages.concat(messages)
          self.start = self.start + data.length
          deferred.resolve(messages)
        }, function (reason) {
          deferred.reject(reason)
        })
      }

      /** miss mids when refreshing */
      if (!self.mids) {
        self.getMid().then(function () {
          fetchMessages()
        })

        return deferred.promise
      }

      fetchMessages()
      return deferred.promise
    }
    // 搜索往来邮件
    KeywordSearchMail.prototype.fetchMailDealings = function (iStart) {
      const self = this
      const deferred = $q.defer()

      iStart = iStart || 0
      self.start = iStart

      if (self.messages[iStart]) {
        deferred.resolve(self.messages.slice(iStart, iStart + (self.limit || 0)))
        return deferred.promise
      }

      /** todo: 是否需要对象的所有数据？ */
      mailService.searchMailDealings(this).then(function (data) {
        const messages = data.var ? Message.buildMessages(data.var) : []
        self.messages = self.messages.concat(messages)
        self.start = self.start + messages.length
        self.totals = data.total
        deferred.resolve(messages)
      }, function (reason) {
        deferred.reject(reason)
      })

      return deferred.promise
    }

    KeywordSearchMail.prototype.loadMoreMessages = function (iStart, mboxa) {
      /** todo: 理应和 StorageMailFolder 类似处理，这里暂时封装多一层 */
      return this.dealings ? this.fetchMailDealings(iStart) : this.fetchMessages(iStart, mboxa)
    }

    KeywordSearchMail.prototype.removeMessages = function (aMessages, mboxa) {
      let message, deferred
      if (aMessages && aMessages.length > 0) {
        message = new Message()
        deferred = message.remove(aMessages, mboxa)
        for (let i = 0; i < aMessages.length; ++i) {
          for (let j = 0; j < this.messages.length; ++j) {
            if (aMessages[i].messageInfo.id == this.messages[j].messageInfo.id) {
              this.messages.splice(j, 1)
              this.totals--
            }
          }
        }
        return deferred
      }
    }

    /** todo: moveMsgsToFolder 和 removeMessages 逻辑可重构 */
    KeywordSearchMail.prototype.moveMsgsToFolder = function (aMessages, oFolder, mboxa) {
      if (aMessages && aMessages.length > 0) {
        const message = new Message()
        const deferred = message.moveToFolder(aMessages, oFolder, mboxa)
        for (let i = 0; i < aMessages.length; ++i) {
          for (let j = 0; j < this.messages.length; ++j) {
            if (aMessages[i].messageInfo.id == this.messages[j].messageInfo.id) {
              this.messages.splice(j, 1)
              this.totals--
            }
          }
        }
        return deferred
      }
    }

    KeywordSearchMail.prototype.getMessages = function () {
      return this.messages
    }

    return KeywordSearchMail
  }]



// WEBPACK FOOTER //
// ./src/js/mail/KeywordSearchMail.js